function uaHas(keyword: string) {
  return navigator.userAgent.toLowerCase().search(keyword.toLowerCase()) > -1;
}

export const isApplePlatform = (): boolean => {
  return uaHas('iphone') || uaHas('ipad') || uaHas('ipod') || uaHas('mac os');
};

export function isSafari() {
  // @ts-expect-error - These properties are not standard but are used to detect Safari
  return (!!window.ApplePaySetupFeature || !!window.safari) && uaHas('Safari') && !uaHas('Chrome') && !uaHas('CriOS');
}
